import React, { useState } from "react";
import {
  Accordion,
  AccordionVariantEnum,
} from "../../../../../components/core/Accordion/Accordion";
import { FontWeightEnum, IconSizeEnum } from "../../../../../types/AppTypes";
import { IconManager } from "../../../../../components/core/IconManager/IconManager";
import { StyledWorkInformationBody } from "../Resume.styled";
import { BodyTyp } from "../../../../../components/Typography/Typography";
import {
  BUSINESS_AREA_MANAGER_COMMENT_LABEL,
  EMPTY_STRING,
} from "../../../../../constants/Dictionary";
import { CollaboratorResume } from "../../../../../types/api/collaborators.type";
import { ReactComponent as CommentIcon } from "../../../../../icons/comment.svg";
import { StyledContainerProfessionalWay } from "./BusinessAreaManagerComment.styled";

export const BusinessAreaManagerComment = ({
  resumeData,
}: {
  resumeData: CollaboratorResume | undefined;
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);

  return (
    <Accordion
      label={
        <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
          {BUSINESS_AREA_MANAGER_COMMENT_LABEL}
        </BodyTyp>
      }
      variant={AccordionVariantEnum.SECONDARY}
      leftComponent={
        <IconManager size={IconSizeEnum.SMALL}>
          <CommentIcon />
        </IconManager>
      }
      onToggle={setIsAccordionOpen}
      isOpen={isAccordionOpen}
    >
      <StyledContainerProfessionalWay>
        <StyledWorkInformationBody>
          <BodyTyp variant="2" fontWeight={FontWeightEnum.REGULAR}>
            {resumeData?.businessAreaManagerComment ?? EMPTY_STRING}
          </BodyTyp>
        </StyledWorkInformationBody>
      </StyledContainerProfessionalWay>
    </Accordion>
  );
};
